import { render, staticRenderFns } from "./PerformanceMarketingView.vue?vue&type=template&id=60303dbe"
import script from "./PerformanceMarketingView.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports